var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveLink24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.464 4.257a.75.75 0 0 1 1.06 1.06l-2.132 2.131a4.78 4.78 0 0 1 3.477 4.597c0 2.617-2.122 4.77-4.75 4.771h-3.322a.75.75 0 0 1 0-1.5h3.322c1.79 0 3.25-1.472 3.25-3.271 0-1.8-1.46-3.271-3.25-3.272h-.052l-2.522 2.522h.546a.75.75 0 0 1 0 1.5h-2.047l-2.574 2.572a.749.749 0 0 1-.266 1.45H9.021l-2.928 2.926a.75.75 0 0 1-1.06-1.06l14.43-14.426Zm-9.26 3.016a.75.75 0 0 1 0 1.5H6.882c-1.79 0-3.25 1.472-3.25 3.272 0 1.8 1.46 3.271 3.25 3.271h.81L6.235 16.77a4.774 4.774 0 0 1-4.105-4.725c0-2.618 2.122-4.772 4.75-4.772h3.323Zm.009 5.522h-1.28a.75.75 0 0 1 0-1.5h2.78l-1.5 1.5Zm4.022-4.022h-.438a.75.75 0 0 1 0-1.5h1.938l-1.5 1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveLink24);
export default __webpack_public_path__ + "static/media/remove_link_24.da75eaba65d8b7a72c7adc77c060e252.svg";
export { ForwardRef as ReactComponent };